import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UPLOAD_WIZARD, UploadService } from './upload.service';
import { IUploadResponse, UploadDataService } from './upload-data.service';
import { GaWizard } from '../../shared/wizard/ga-wizard';
import { GaWizardService } from '../../shared/wizard/ga-wizard.service';

@Component({
  selector: 'upload-results',
  template: `
    <div [class.message-dialog]="inDialog">
      <div class="modal-header" *ngIf="inDialog">
        <h4 class="modal-title" translate>GA.UPLOADS.TEST_RESULT</h4>
      </div>

      <div [class.modal-body]="inDialog">
        <h2 *ngIf="loading">
          <activity-indicator [useDefaultText]="true" class="no-margin"></activity-indicator>
        </h2>

        <div class="row" *ngIf="!loading && result">
          <div class="col-sm-12 col-space-bottom success-row">
            <h2 class="text-success no-margin col-space-bottom"><i class="fa fa-check-circle"></i> Success</h2>

            <div class="col-space-top">
              <p [translateParams]="{count: result.success }" translate>GA.UPLOADS.ROW_SUCCESS</p>
            </div>
          </div>

          <div class="col-sm-12 col-space-bottom form-horizontal warning-row">
            <h2 class="text-warning-2"><i class="fa fa-exclamation-triangle"></i> Warning ({{(result?.warnings?.length || 0) | number}})</h2>

            <select class="form-select form-select-sm" multiple>
              <option *ngFor="let list of result.warnings" [innerHTML]="'Row ' + list.rowId + ': ' + list.error"></option>
            </select>
          </div>

          <div class="col-sm-12 col-space-bottom form-horizontal error-row">
            <h2 class="text-danger"><i class="fa fa-info-circle"></i> Error ({{(result?.errors?.length || 0) | number}})</h2>

            <select class="form-select form-select-sm" multiple>
              <option *ngFor="let list of result.errors" [innerHTML]="'Row ' + list.rowId + ': ' + list.error"></option>
            </select>
          </div>
        </div>
      </div>

      <div class="modal-footer footer-margin" *ngIf="inDialog">
        <button class="btn btn-default" (click)="onDialogClose.emit()" translate>GA.BUTTONS.CLOSE</button>
      </div>
    </div>
  `
})
export class UploadResultsComponent implements OnInit {
  @Input() public code:string;
  @Input() public inDialog:boolean;
  @Input() public result:IUploadResponse;
  @Output() public onDialogClose:EventEmitter<void> = new EventEmitter<void>();

  public loading:boolean;
  private wizard:GaWizard;

  constructor(
    private wizardService:GaWizardService,
    private uploadDataService:UploadDataService,
    private uploadService:UploadService
  ) {
    /**/
  }

  public ngOnInit():void {
    if (!this.inDialog) {
      this.wizard = this.wizardService.getInstance(UPLOAD_WIZARD);

      // set title
      this.wizard.title = 'GA.UPLOADS.UPLOAD_FINISHED';

      // clear steps and actions here
      this.wizard.steps([]);
      this.wizard.actions([]);
    }

    if (!this.result) {
      this.getUploadResults();
    }
  }

  private updateLoadingStatus(loading?:boolean):void {
    this.loading = loading;

    if (!this.inDialog) {
      this.wizard.title = loading? '' : 'GA.UPLOADS.UPLOAD_FINISHED';
    }
  }

  private getUploadResults():void {
    this.updateLoadingStatus(true);

    this.uploadDataService.getUploadResults(this.uploadService.model.uploadContext.importId)
      .then((res:IUploadResponse) => {
        this.result = res;
      })
      .finally(() => {
        this.updateLoadingStatus(false);
      });
  }
}